import request from '@/api/request.js'
export function count(data) {
  return request({
    url: '/homePage/count?organId=' + data.organId,
    method: 'get',
  })
}
export function latestIntelligence(data) {
  return request({
    url: '/homePage/latestIntelligence?organId=' + data.organId,
    method: 'get',
  })
}
export function deptList(data) {
  return request({
    url: '/agency/deptList',
    method: 'post',
    data: data
  })
}
// 所属大区
export function allAreaInfo() {
  return request({
    url: '/publicOpinionFindings/allAreaInfo',
    method: 'get'
  })
}

//信息类型
export function allInfoType() {
  return request({
    url: '/publicOpinionFindings/allInfoType',
    method: 'get'
  })
}

//事件来源
export function allPlatFormSource() {
  return request({
    url: '/publicOpinionFindings/allPlatFormSource',
    method: 'get'
  })
}
//退出登录
export function logout() {
  return request({
    url: '/logout',
    method: 'get'
  })
}
export default {
  count,
  latestIntelligence,
  deptList,
  allAreaInfo,
  allInfoType,
  allPlatFormSource,
  logout
}